import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedPolling } from '@eggplant/data-request'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  Error,
  GetRunsResponse,
  GetTestResultsParams
} from '@eggplant/types'

interface Props {
  onError?: (error: Error) => void
  onSuccess?: (data: GetRunsResponse) => void
  params?: GetTestResultsParams
  interval?: number
  isPolling: boolean
  children?: (data: GetRunsResponse) => React.ReactElement
}

const PollAiRunsRequest = ({
  onError,
  onSuccess,
  params,
  interval = 5000,
  isPolling,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/runs`

  const { requestParams } = useGetParamsWithSpaceId<GetTestResultsParams | undefined>(params)

  return (
    <AuthenticatedPolling<GetRunsResponse>
      children={children}
      intervalMs={interval}
      isPolling={isPolling}
      onError={onError}
      onSuccess={onSuccess}
      params={requestParams}
      url={url}
    />
  )
}

export default PollAiRunsRequest
